var _defs, _circle, _line, _line2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack384({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}.b{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 4.9,
    cy: 9.13,
    r: 2.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.15,
    y1: 9.13,
    x2: 9.65,
    y2: 9.13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 4.9,
    y1: 4.39,
    x2: 4.9,
    y2: 13.88
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.86,5l.42,0a1.19,1.19,0,0,0,.15.52.91.91,0,0,0,.34.3,1,1,0,0,0,.49.11.88.88,0,0,0,.61-.19A.66.66,0,0,0,9,4.84a.52.52,0,0,0-.24-.22,4.86,4.86,0,0,0-.69-.25,2.19,2.19,0,0,1-.67-.28.9.9,0,0,1-.31-.36A1,1,0,0,1,7,3.24a1.06,1.06,0,0,1,.32-.81,1.16,1.16,0,0,1,.86-.31,1.38,1.38,0,0,1,.65.15,1,1,0,0,1,.43.42,1.44,1.44,0,0,1,.17.64L9,3.37a.87.87,0,0,0-.24-.59.81.81,0,0,0-.57-.19.86.86,0,0,0-.57.17.56.56,0,0,0-.2.44.49.49,0,0,0,.15.38,1.64,1.64,0,0,0,.65.27,4.57,4.57,0,0,1,.69.24,1.16,1.16,0,0,1,.46.41,1.18,1.18,0,0,1,.16.61,1.24,1.24,0,0,1-.17.63,1.16,1.16,0,0,1-.44.44,1.45,1.45,0,0,1-.68.15,1.38,1.38,0,0,1-1-.37A1.46,1.46,0,0,1,6.86,5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10,5l.41,0a1.33,1.33,0,0,0,.16.52.88.88,0,0,0,.33.3,1,1,0,0,0,.5.11A.89.89,0,0,0,12,5.65a.65.65,0,0,0,.22-.5.62.62,0,0,0-.08-.31.64.64,0,0,0-.24-.22,4.86,4.86,0,0,0-.69-.25,2.08,2.08,0,0,1-.67-.28.83.83,0,0,1-.31-.36,1,1,0,0,1-.11-.49,1.09,1.09,0,0,1,.31-.81,1.19,1.19,0,0,1,.87-.31,1.38,1.38,0,0,1,.65.15,1,1,0,0,1,.43.42,1.32,1.32,0,0,1,.16.64l-.42,0a.87.87,0,0,0-.24-.59.81.81,0,0,0-.57-.19.86.86,0,0,0-.57.17.56.56,0,0,0-.2.44.52.52,0,0,0,.14.38,1.79,1.79,0,0,0,.65.27,5.3,5.3,0,0,1,.7.24,1.23,1.23,0,0,1,.46.41,1.17,1.17,0,0,1,.15.61,1.23,1.23,0,0,1-.16.63,1.12,1.12,0,0,1-.45.44,1.38,1.38,0,0,1-.67.15,1.34,1.34,0,0,1-1-.37A1.41,1.41,0,0,1,10,5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.4,2.19h.45V4.54a3.24,3.24,0,0,1-.12,1,1.18,1.18,0,0,1-.42.6,1.25,1.25,0,0,1-.77.22,1.22,1.22,0,0,1-1-.39,2.24,2.24,0,0,1-.33-1.4V2.19h.44V4.54a2.57,2.57,0,0,0,.09.8.71.71,0,0,0,.28.37.82.82,0,0,0,.48.13.84.84,0,0,0,.68-.26,1.81,1.81,0,0,0,.21-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack384);
export default __webpack_public_path__ + "static/media/Symbol_pack_384.06b653f20f4a8e93ca2f77359fd3a659.svg";
export { ForwardRef as ReactComponent };